// extracted by mini-css-extract-plugin
module.exports = {"star-disabled":"style_star-disabled__0tuCo","starDisabled":"style_star-disabled__0tuCo","stars":"style_stars__ujuLU"};